// extracted by mini-css-extract-plugin
export default {"w-full":"Favorite_w-full__988Ev","button":"Favorite_button__fIIdk","active":"Favorite_active__DsbVt"};